<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Zsj6xl/tc-custom/9780830894970.jpg?1696024622312" alt="This image is the cover for the book Mark, Tyndale New Testament Commentaries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mark, Tyndale New Testament Commentaries
      </h1>
      <p class="bookDescription body article font2">
        <p>Mark wrote his Gospel to explain why and how Jesus is the Messiah and Son of God who fulfills God's promises as he proclaims and embodies the coming kingdom of God. Mark emphasizes Jesus' authority and also his suffering and death as God's will for his messianic mission. This Tyndale New Testament commentary from Eckhard Schnabel seeks to help today's Christian disciples communicate the significance of Jesus and the transforming power of the good news. An exegetical commentary on the Gospel of Mark, this volume will be useful for preachers, Bible teachers, and non-specialists alike.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Eckhard J. Schnabel
      </h2>
      
      <p class="authorDescription body article"><p>Eckhard J. Schnabel (PhD, University of Aberdeen) is Mary F. Rockefeller Distinguished Professor of New Testament Studies at Gordon-Conwell Theological Seminary in South Hamilton, Massachusetts. He has taught previously at Trinity Evangelical Divinity School (Deerfield, Illinois), Freie Theologische Akademie (Giessen, Germany), Wiedenest Bible College (Bergneustadt, Germany), and Asian Theological Seminary (Manila, Philippines). His books include <em>Early Christian Mission</em> (volumes 1  2), <em>Paul the Missionary</em>, and <em>Der erste Brief des Paulus an die Korinther</em>. He is the author of numerous articles, including "Luke" (with David W. Pao) in <em>Commentary on the New Testament Use of the Old Testament</em> and contributions in <em>Dictionary of Paul and His Letters</em> and <em>Dictionary of the Later New Testament  Its Developments.</em> </p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f1cd57ae